import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { cloneElement } from 'react';
import Box from '@mui/material/Box';
import { BodyS } from '../../../typography';
import { Caption } from '../../../typography';
import { useTheme } from '../../../theme';
import { IconButton } from '../../iconButton';
import { Link } from '../../link';
import { useIntl } from '@doxyme/locale';
import { Icon } from '@doxyme/icons';
export const TooltipRich = ({ icon, title, body, actionText, className, onClick, onClose })=>{
    const theme = useTheme('dark');
    const { formatMessage } = useIntl();
    return /*#__PURE__*/ _jsxs(Box, {
        className: className,
        sx: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 2,
            padding: 1
        },
        children: [
            Boolean(icon) && /*#__PURE__*/ cloneElement(icon, {
                css: {
                    flexShrink: 0,
                    width: 20,
                    height: 20
                }
            }),
            /*#__PURE__*/ _jsxs(Box, {
                sx: {
                    display: 'flex',
                    width: 191,
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: 2
                },
                children: [
                    (Boolean(title) || Boolean(body)) && /*#__PURE__*/ _jsxs(Box, {
                        sx: {
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: 2,
                            alignSelf: 'stretch'
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(Box, {
                                sx: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-start',
                                    gap: 1,
                                    flex: '1 0 0',
                                    alignSelf: 'stretch'
                                },
                                children: [
                                    Boolean(title) && /*#__PURE__*/ _jsx(BodyS, {
                                        fontWeight: "medium",
                                        color: theme.text.generic.primary,
                                        children: title
                                    }),
                                    Boolean(body) && /*#__PURE__*/ _jsx(Caption, {
                                        color: theme.text.generic.secondary,
                                        children: body
                                    })
                                ]
                            }),
                            Boolean(onClose) && /*#__PURE__*/ _jsx(IconButton, {
                                themeName: "dark",
                                size: "xSmall",
                                type: "subtle",
                                "aria-label": formatMessage({
                                    id: 'close'
                                }),
                                onClick: ()=>onClose?.(),
                                icon: /*#__PURE__*/ _jsx(Icon.Close, {
                                    size: "xsmall"
                                })
                            })
                        ]
                    }),
                    Boolean(actionText) && /*#__PURE__*/ _jsx(Link, {
                        size: "small",
                        onClick: onClick,
                        themeName: "dark",
                        children: actionText
                    })
                ]
            })
        ]
    });
};

//# sourceMappingURL=rich.js.map